<template>
  <v-fade-transition mode="out-in">
    <v-overlay v-if="value">
      <div class="backdrop">
        <div class="ball-wrapper">
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
        </div>
        <div 
          class="mt-6 pt-5" 
          v-if="message">
          {{ message }}
        </div>
      </div>
    </v-overlay>
  </v-fade-transition>
</template>

<script>
import VFadeTransition from '@/components/transitions/VFadeTransition'
import VOverlay from '@/components/base/VOverlay'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    }
  },
  components: { VOverlay, VFadeTransition }
}
</script>

<style scoped>
.backdrop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.ball-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ball {
  width: 35px;
  height: 35px;
  transition: all 0.3s ease-in-out;
  animation: bounce 0.5s, fadein 0.8s;
  animation-direction: alternate;
  animation-timing-function: cubic-bezier(.5, 0.05, 1, .5);
  animation-iteration-count: infinite;
}

@keyframes bounce {
  from { transform: translate3d(0, -50px, 0); }
  to   { transform: translate3d(0, 50px, 0); }
}

/* Prefix Support */
.ball {
  background: #00d1b2;
  width: 15px;
  height: 15px;
  margin: 5px 5px;
  border-radius: 50%;
  -webkit-animation-name: bounce;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-direction: alternate;
  -webkit-animation-timing-function: cubic-bezier(.5, 0.05, 1, .5);
  -webkit-animation-iteration-count: infinite;
}

@-webkit-keyframes bounce {
  from { -webkit-transform: translate3d(0, -50px, 0); transform: translate3d(0, -50px, 0); }
  to   { -webkit-transform: translate3d(0, 50px, 0); transform: translate3d(0, 50px, 0); }
}

.ball:nth-child(1) {
  animation-delay: 0.03;
}
.ball:nth-child(2) {
  animation-delay: 0.15s;
}
.ball:nth-child(3) {
  animation-delay: 0.09s;
}
.ball:nth-child(4) {
  animation-delay: 0.23s;
}
.ball:nth-child(5) {
  animation-delay: 0.35s;
}

@-webkit-keyframes fadein {
  from {
    opacity: 0.3;
  }
  to {
    opacity: 0.8;
  }
}
@keyframes fadein {
  from {
    opacity: 0.3;
  }
  to {
    opacity: 0.8;
  }
}
</style>